export function getFilters(filtersMap, isLive) {
    if (isLive && typeof filtersMap === 'object') {
        filtersMap['LIVE'] = 1;
    }
    
    return filtersMap;
}
